import
{
  SAVE_USER_INFO,
  SAVE_COURSE_DATA,
  SAVE_COURSE_BUY_STATUS,
  SAVE_COURSE_BUY_STATUS_FOR_COURSE_LIST,
  SAVE_PRODUCT_SKU,
  SAVE_CURRENT_ENV,
  CHANGE_LOGIN_POPUP_STATUS,
  SAVE_ALL_ACVITITY,
  SAVE_CURRICULUM_DATA,
  UPDATE_CURRENT_TIME,
  SAVE_COURSE_BASE_DATA,
  SAVE_ADDRESS_INFO,
  SET_CURRENT_YEAR,
  SAVE_USER_PHONE,
  SAVE_ACTIONS_TYPE,
  SAVE_COURSE_INFO,
  SAVE_COURSE_SIMPLE_DATA,
  SAVE_GROUP_BUY_DETAIL,
  SET_ORDER_ADDRES,
} from './mutations-type';

export default {
  [SAVE_USER_INFO](state, data) {
    state.userInfo = data;
  }, // 保存用户信息
  [SAVE_COURSE_DATA](state, data) {
    state.courseBaseData = data;
  }, // 保存课程信息
  [SAVE_COURSE_SIMPLE_DATA](state, data) {
    state.courseSimpleData = data;
  }, // 保存课程信息
  [SAVE_COURSE_BUY_STATUS](state, data) {
    state.buyStatus = data;
  }, // 保存课程购买者状态
  [SAVE_COURSE_BUY_STATUS_FOR_COURSE_LIST](state, data) {
    state.buyStatusForCourseList = data;
  }, // 为判断课程列表是否可点击保存课程购买状态
  [SAVE_PRODUCT_SKU](state, data) {
    state.productSku = data;
  }, // 保存选择的sku
  [SAVE_CURRENT_ENV](state, env) {
    state.currentEnv = env;
    console.log(state.currentEnv);
  }, // 保存当前环境
  [CHANGE_LOGIN_POPUP_STATUS](state, data) {
    state.loginControl = data;
  }, // 保存当前环境
  [SAVE_ALL_ACVITITY](state, data) {
    state.allAcvitity = data;
  },
  // 保存课表信息
  [SAVE_CURRICULUM_DATA](state, data) {
    state.containCurriculumData = data;
  },
  // 更新时间
  [UPDATE_CURRENT_TIME](state, data) {
    state.currentTime = data;
  },
  // 保存课程基本信息
  [SAVE_COURSE_BASE_DATA](state, data) {
    state.courseBaseData = data;
  },
  // 保存地址信息
  [SAVE_ADDRESS_INFO](state, data) {
    state.addressInfo = data;
  },
  // 设置考季
  [SET_CURRENT_YEAR](state, data) {
    // console.log(data, 44455);
    state.currentYear = data;
  },
  [SAVE_USER_PHONE](state, data) {
    state.userPhone = data;
  },
  // 设置登录
  [SAVE_ACTIONS_TYPE](state, data) {
    state.actionType = data;
  },
  [SAVE_COURSE_INFO](state, data) {
    state.courseInfo = data;
  },
  // 拼团详情
  [SAVE_GROUP_BUY_DETAIL](state, data) {
    state.groupBuyDetailVuex = data;
  },
  // bilibili订单地址
  [SET_ORDER_ADDRES](state, data) {
    state.bilibiliOrderDetails = data;
  },
};
